/**
 * <s-shaver-reminder>: small floating free-shaver reminder.
 * Shows after the visitor scrolls 500px, hides again near the top; the close button hides it for the rest of the visit (sessionStorage).
 */
const KEY = "steamrs:shaver-reminder-closed";

class ShaverReminder extends HTMLElement {
  connectedCallback() {
    let closed = false;
    try {
      closed = sessionStorage.getItem(KEY) === "1";
    } catch (e) {}
    if (closed) return;
    this.hidden = false;
    this.onScroll = () => {
      if (window.scrollY > 500) this.setAttribute("data-shown", "");
      else this.removeAttribute("data-shown");
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
    this.querySelector("[data-reminder-close]")?.addEventListener("click", () => {
      try {
        sessionStorage.setItem(KEY, "1");
      } catch (e) {}
      this.removeAttribute("data-shown");
      window.removeEventListener("scroll", this.onScroll);
      setTimeout(() => (this.hidden = true), 300);
    });
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll);
  }
}

if (!customElements.get("s-shaver-reminder")) customElements.define("s-shaver-reminder", ShaverReminder);
